import { Component, OnInit, Input} from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-searchable-select-modal',
  templateUrl: './searchable-select-modal.component.html',
  styleUrls: ['./searchable-select-modal.component.scss'],
})
export class SearchableSelectModalComponent implements OnInit {

  @Input() options: Array<string>;

  /**
   * Optional section headers. When supplied the list renders grouped; when it
   * is absent the component behaves exactly as before and renders `options`
   * as one flat list, so the callers that do not group are untouched.
   */
  @Input() groups: Array<{ label: string; options: string[] }>;

  @Input() selectedOptions: Array<string> = [];

  @Input() onCancel;
  
  @Input() onSelect;

  @Input() multiple : Boolean = false

  /** The field's own label, so the picker names what it is picking. */
  @Input() labelText: string = '';

  searchItem: string;

  originalOptions : Array<string>=[] 

  /** What the template renders: always sections, even when there is only one. */
  sections: Array<{ label: string; options: string[] }> = [];

  private originalSections: Array<{ label: string; options: string[] }> = [];

  constructor( private modalController: ModalController){
  }

  ngOnInit() {
    this.originalOptions=[...this.options]
    this.originalSections = this.groups && this.groups.length
      ? this.groups.map(g => ({ label: g.label, options: [...g.options] }))
      : [{ label: '', options: [...(this.options || [])] }];
    this.sections = this.originalSections;
  }

  /** Sections with no matches are dropped so the headers do not float alone. */
  private applyFilter(term: string) {
    const q = (term || '').toLowerCase();
    this.sections = this.originalSections
      .map(g => ({ label: g.label, options: g.options.filter(o => o.toLowerCase().includes(q)) }))
      .filter(g => g.options.length);
  }

  /** True while a search matches nothing at all. */
  get hasNoMatches(): boolean {
    return !this.sections.length;
  }

  /**
   * Field labels carry the required marker ('* Skill'); the heading should not.
   */
  get headingText(): string {
    const label = (this.labelText || '').replace(/^\s*\*\s*/, '').trim();
    return label || 'Select';
  }

  /** Standing count for a multi-select, plain guidance for a single one. */
  get subheadingText(): string {
    if (!this.multiple) { return 'Pick one'; }
    const n = (this.selectedOptions || []).length;
    return n === 1 ? '1 selected' : n + ' selected';
  }

  /**
   * 
   * @param option 
   * @description this function checks whether option is preselected or not 
   */

  isSelectedOption(option : string){
    return this.selectedOptions.includes(option)
  }

  /**
   * 
   * @param check 
   * @param option 
   * @description this function called on checkbox changes
   */
  handleCheckboxSelect(check: Boolean, option:string){
    if(check && !this.multiple){
      this.selectedOptions = []
    }

    if (check) {
      this.selectedOptions.push(option)
    } else {
      this.selectedOptions= this.selectedOptions.filter(item=>item!==option)
    }
  }

  /**
   * @description this function called on searchbar changes
   */
  handleSearchChange(){
    if(!this.searchItem){
      this.handleClearSearch()
      return;
    }
    this.options=this.originalOptions.filter(item=>{
        return item.toLowerCase().includes(this.searchItem.toLowerCase())
    })
    this.applyFilter(this.searchItem);
  }


  /**
   * @description this function called on clear searchbar change
   */
  handleClearSearch(){
    this.options=[...this.originalOptions]
    this.sections = this.originalSections;
  }

}
